import { Log } from './shared/log';
const log = new Log('app.config');

import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { customerCards } from './shared/customer-cards';

@Injectable()
export class AppConfig {
  private FEEDBACK_CUTOFF_DATE = new Date(2200, 11, 31); // months are 0-based, days 1-based. Setting to a long distance future date so that it practically does not expire (QOL-239).

  private config = {};
  private defaults = {
    loginUrl: '/',
    useAuth0: true,
    auth0Config: {},
    feedbackCutOffDate: this.FEEDBACK_CUTOFF_DATE,
    customerCards: customerCards,
    seniorsThresholdAge: 60,
    enableSharing: [
      {
        name: 'enable_sharing',
        label: 'Pre-fill fields with my personal details',
        // aria label must be 32 characters or less or else the screen reader won't read it out
        ariaLabel: 'Pre-fill fields with my details',
        checked: true
      }
    ],
    changeOfAddressUrl: 'https://services.qld.gov.au/cofa/change-of-address/index.html',
    seniorsDiscountsUrl: 'https://secure.communities.qld.gov.au/chiip/',
    registrationRenewalUrl: 'https://www.service.transport.qld.gov.au/renewregistration',
    listMyJpDetailsUrl: 'https://www.qld.gov.au/law/legal-mediation-and-justice-of-the-peace/jp-and-cdec-information/update-your-jp-or-cdec-details/list-your-contact-details/',
    emergencyHospitalsUrl: 'https://www.healthdirect.gov.au',
    qldGovSearchUrl: 'https://find.search.qld.gov.au/s/suggest.json'
  };

  public static app_initializer(config: AppConfig) {
    return (() => config.load());
  }

  constructor(private http: Http) {}

  public getConfig() {
    return this.config;
  }

  public getValue(key) {
    return this.config[key];
  }

  public load(): Promise<any> {
    const configFile = 'config.json?v=' + Date.now();
    return this.http.get(configFile)
        .map( res => res.json() )
        .toPromise()
        .catch((error: any): any => {
          log.error(`Configuration file '${configFile}' could not be read`, error);
          throw error;
        })
        .then((envConfig) => {
          this.setConfig(envConfig);
        });
  }

  private setConfig(envConfig) {
    this.config = Object.assign({}, this.defaults, envConfig);
  }

}



// WEBPACK FOOTER //
// ./app/app.config.ts